import { Authorities } from '@/supporting/account/domain/Authorities.ts';
import { OrganizationId } from '@/supporting/account/domain/OrganizationId.ts';

type OrganizationToCreate = {
  id: OrganizationId | string;
  name: string;
  authorities?: Authorities;
};

export class Organization {
  readonly #id: OrganizationId;
  readonly #name: string;
  readonly #authorities: Authorities;

  private constructor({ id, name, authorities }: OrganizationToCreate) {
    this.#id = OrganizationId.of(id);
    this.#name = name;
    this.#authorities = authorities ?? Authorities.of();
  }

  static of(organization: OrganizationToCreate): Organization {
    return new Organization(organization);
  }

  get id(): OrganizationId {
    return this.#id;
  }

  get name(): string {
    return this.#name;
  }

  get authorities(): Authorities {
    return this.#authorities;
  }
}
